import React, {useEffect, useState} from 'react';
import {Button} from 'reactstrap';
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import Badge from "reactstrap/es/Badge";
import localeHelpers from "../../helpers/LocaleHelper";
import {resource_strings} from "../../translations/resource_translations";
import {MdDelete} from 'react-icons/md';

let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);

function localize() {
    const loc = localeHelpers.currentLocale();

    commonStrings.setLanguage(loc);
    resourceStrings.setLanguage(loc);
}

const PPTableRow = (props) => {
    const [ppItem, setPPItem] = useState(props.ppItem);
    localize();

    useEffect(() => {
        if (props.ppItem != ppItem) {
            setPPItem(props.ppItem)
        }
    });

    function displayDeleteButton() {
        return (ppItem.name.includes(resourceStrings.public_profile.background) || ppItem.name.includes(resourceStrings.logo)) && ppItem.done
    }

    return (
        <div
            onClick={e => ppItem.action(e)}
            style={{
                cursor: "pointer",
                borderRadius: 10,
                backgroundColor: "white",
                padding: 10,
                width: "99%",
                textAlign: "left",
                marginTop: 4,
                marginBottom: 8,
                marginLeft: 4,
                marginRight: 4
            }}
            color="secondary">

            {displayDeleteButton() &&
                <Button onClick={e => ppItem.deleteAction(e)} size="sm" color="warning"
                        className="float-right"><MdDelete/></Button>
            }
            <h3>{ppItem.name}
                <span className="align-items-center ml-2 mb-4">
                    <small>
                        {ppItem.done ?
                            (
                                <Badge color="success">
                                    ✔️
                                </Badge>
                            ) :
                            (
                                <Badge
                                    color={(ppItem.required === commonStrings.required) ? "warning" : "info"}>
                                    {ppItem.required}
                                </Badge>
                            )}
                    </small>
                </span>
            </h3>
            <div className="align-items-start">
                <small>
                    <span style={{overflowWrap: 'break-word', whiteSpace: "pre-line"}}>
                        {ppItem.description}
                    </span>
                </small>

                {ppItem.imageUrl &&
                    <div
                        className=""
                        style={{
                            width: 300,
                            borderRadius: 10,
                            marginTop: 10,
                            backgroundSize: "cover",
                            backgroundImage: "url(" + ppItem.imageUrl + ")",
                            backgroundPosition: "center",
                            minHeight: 150,
                            backgroundRepeat: "no-repeat"
                        }}
                    />
                }
            </div>
        </div>
    )
};

export default PPTableRow;